module.exports = __webpack_public_path__ + "media/images/badge/coppa-italia-vincente_secondary-6ce2c9930c856f1582b83aaa5bc28e8f.png";